import { IAppState } from '../../redux';
import { ETopBetsErrorCode } from '../../redux/reducers';

export function selectTopBetsErrorCode(state: IAppState): ETopBetsErrorCode | null {
  const {
    topBets: { errorCode },
  } = state;

  return errorCode;
}
